
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import Tooltip from '../../shared/UI/Tooltip/Tooltip';
import Messages from '../../shared/UI/Messages/Messages';
import { Link } from 'react-router-dom';
import UserInfo from '../../shared/UserInfo/UserInfo';
import axios from '../../axios-url';
import { Toast } from 'primereact/toast';
import * as actions from '../../store/actions/index';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import moment from 'moment';
import "./styles.css"
import Vendor from '../Masters/Vendor/Vendor';
import CostCenter from '../Masters/CostCenter/CostCenter';
import { filter } from 'lodash';
import jsPDF from 'jspdf';
import { chenthoorLandscapeLogo } from '../../shared/fontsAndBitImages';

const PAYROLL_ID = '1D997738-6764-4DAB-ADBB-F403CD5AE13B';
let currentStage = 0;

const test = {
    "Table": [
        {
            "EmployeeIdu": "db4baf84-2a26-4707-9414-abd65529f70b",
            "EmployeeId": 10660,
            "Name": "GulShahzad",
            "PrestentDays": 20,
            "AbsentDays": 19,
            "TotalShiftDays": 0,
            "OffDays": 16,
            "TotalWorkHours": 120.0,
            "RegulerWorkHours": 118.05,
            "RequiredHours": 1.95,
            "LateIn": 6,
            "earlyout": 9,
            "PreApprovedOT": 0.0,
            "ActualOT": 0.0,
            "PermissionHours": 0,
            "UnPaidLeave": 0,
            "POSITION": "Admin Assistant",
            "DEPARTMENT": "ADM - GENERAL SERVICES",
            "EMPLOYEETYPE": null,
            "Division": null,
            "SponserName": null
        }
    ]
}

class AddPayrollReport extends Component {

    constructor() {
        super();
        this.state = {
            organizationunit: null,
            employee: null,
            organizationData: [],
            comment: '',
            startDate: null,
            endDate: null,
            requestDate: new Date(),
            commonData: [],
            processData: null,
            approverComment: '',
            employeeData: [],
            payrollData: [
            ],
            expandedRows: null,
            DivisionData: [],
            BusinessUnitData: [],
            DepartmentData: [],
            SectionData: [],
            Division: false,
            BusinessUnit: false,
            Department: false,
            Section: false,
            Generate: false,

            // fieldsfor filter dropdowns
            filterApplied: false,
            Vendor: [],
            CostCenter: [],
            employeeType: [],
            employeeSubGroup: [],
            nationality: [],
            employeeStatus: [],
            OrgUnit: [],
            filteredEmployeelist: [],

        };
        this.clickSimulateForEdit = false;
        this.isFieldUpdated = true;
        this.onEmployeeChange = this.onEmployeeChange.bind(this);
        this.clearEmployeeFilter = this.clearEmployeeFilter.bind(this);
        // this.getEmployeeListOrg = this.getEmployeeListOrg.bind(this);
    }

    componentDidMount() {
        const { getMasterKeywordList, location = {} } = this.props;

        this.props.getContainerData(PAYROLL_ID);
        this.props.getEmployeeDivisionData({});

        const type = this.props.match.params.type;
        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
            this.isFieldUpdated = false;
        }

        this.getEmployeeList();
        // For filter Dropdowns 
        getMasterKeywordList('Employee');//Get Employee Dropdown list
        getMasterKeywordList('Vendor');
        getMasterKeywordList('EMPLOYEETYPE');
        getMasterKeywordList('employeesubgroup');
        getMasterKeywordList('nationality/keyword');
        getMasterKeywordList('EmployeeStatus');
        getMasterKeywordList('CostCenter');
        getMasterKeywordList('OrgUnit');

        const stageSequence = (location.state && location.state.stagesequence != null) ? location.state.stagesequence : this.state.stageSequence;
        const requestId = this.props.match.params.id || this.state.requestId;
        this.setState({ loading: true, stageSequence, requestId });
    }

    componentDidUpdate() {

        const { tableLists } = this.props;
        const { employee, startDate, endDate, comment, requestDate } = this.state;

        if (this.clickSimulateForEdit && employee && startDate && endDate && comment && requestDate) {
            this.simulateOnClick();
            this.clickSimulateForEdit = false;
        }

        if (!this.isFieldUpdated && tableLists && Array.isArray(tableLists.requestAttribute1) && tableLists.requestAttribute1.length > 0) {
            const targetProcess = tableLists.requestAttribute1;
            const stageSequence = targetProcess[0] && targetProcess[0].stageSequence != null ? targetProcess[0].stageSequence : this.state.stageSequence;
            currentStage = stageSequence;
            let processData = { stage: [] };
            processData.stage.push(targetProcess);
            this.setState({ processData, stageSequence });
            this.updateFields(targetProcess);
            this.clickSimulateForEdit = true;
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps && nextProps.processData && Object.keys(nextProps.processData).length > 0 && !prevState.processData) {
            return { processData: nextProps.processData };
        }
    }

    saveRequest = (type) => {

        if (!this.state.employee || !this.state.startDate || !this.state.endDate || !this.state.comment || !this.state.requestDate) {
            if (!this.state.employee) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Select Employee Before Generating Data' })
                return
            } else if (!this.state.startDate) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Select From Date Before Generating Data' })
                return
            } else if (!this.state.endDate) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Select To Date Before Generating Data' })
                return
            } else if (!this.state.comment) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Enter Your Comments Before Generating Data' })
                return
            } else if (!this.state.requestDate) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Select Request Date Before Generating Data' })
                return
            } else {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Something Went Wrong' })
                return
            }
        }

        this.setState({ loading: true });
        let groupAttributes = [];
        let RequestAttributes = [];
        const { processData, stageSequence } = this.state;
        const stage = processData && processData.stage && processData.stage[0];

        stage && stage.stage_Field && stage.stage_Field.map((field, index) => {
            const { stageSequence } = stage;
            const fieldValue = (field.fieldDescription === 'Employee' ? this.state.employee.map(emp => emp.userNo).join(',') : field.fieldDescription === "From Date" ? moment(this.state.startDate).format('MM/DD/YYYY') : field.fieldDescription === "To Date" ? moment(this.state.endDate).format('MM/DD/YYYY') : field.fieldDescription === "Comment" ? this.state.comment : field.fieldDescription === 'Request Date' ? this.state.requestDate : this.state.employee.map(f => f.employeeId).join(','));
            let val = {
                ...field,
                DataType: "string",
                fieldValue: fieldValue || field.fieldValue,
                IsActive: true,
                CompanyID: this.props.loggedUserDetail.CompanyId,
                ContainerType: null,
                stageSequence: 0
            }
            groupAttributes.push(val);
        });

        // Add filter values to groupAttributes
        const filterFields = [
            { fieldDescription: 'Vendor', value: (this.state.Vendor || []).map(v => v.label || v.name || v.value).join(',') },
            { fieldDescription: 'Cost Center', value: (this.state.CostCenter || []).map(v => v.label || v.name || v.value).join(',') },
            { fieldDescription: 'Employee Status', value: (this.state.EmployeeStatus || []).map(v => v.label || v.name || v.value).join(',') },
            { fieldDescription: 'Employee Type', value: (this.state.EmployeeType || []).map(v => v.label || v.name || v.value).join(',') },
            { fieldDescription: 'Organization Unit', value: (this.state.Orgunit || []).map(v => v.label || v.name || v.value).join(',') },
            { fieldDescription: 'Employee Sub Group', value: (this.state.EmployeeSubGroup || []).map(v => v.label || v.name || v.value).join(',') },
            { fieldDescription: 'Nationality', value: (this.state.Nationality || []).map(v => v.label || v.name || v.value).join(',') }
        ];

        filterFields.forEach(filterField => {
            if (filterField.value) {
                groupAttributes.push({
                    fieldDescription: filterField.fieldDescription,
                    DataType: "string",
                    fieldValue: filterField.value,
                    IsActive: true,
                    CompanyID: this.props.loggedUserDetail.CompanyId,
                    ContainerType: null,
                    stageSequence: 0
                });
            }
        });

        if (stageSequence == 1) {
            let approverField = this.props.processData && this.props.processData.stage[1] && this.props.processData.stage[1].stage_Field[0];
            groupAttributes.push({ ...approverField, fieldValue: this.state.approverComment, stageSequence: 1 });
        }
        let data = {
            FromDate: this.state.startDate,
            ToDate: this.state.endDate,
            RequestDesc: 'Payroll Report',
            Remark: this.state.comment,
            IsActive: true,
            RequestDate: new Date(),
            RequestedFor: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            EmpID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            RequestAttributes: groupAttributes,
            Requestattachments: [],
            Requestforms: [],
            Requestactions: [],
            StageSequence: currentStage,
            RequestPayroll: this.getRequestPayroll(),
            ProcessID: PAYROLL_ID
        }

        if (this.state.requestId) {
            data.requestId = this.state.requestId
        }

        data.EmpID = this.props.loggedUserDetail.empID;

        var dd = JSON.stringify(data);
        var datas = { Key: dd };
        if (type != 'submit' && this.state.stageSequence != '1')
            type = this.props.match.params.type === 'edit' ? 'edit' : type;
        let url = type === 'submit' ? '/master/api/workflow/submit?type=PayrollReport' : type === 'cancel' ? '/master/api/workflow/submit?type=PayrollReport' :
            type == 'reject' ? '/master/api/workflow/reject?type=PayrollReport' : type === 'edit' ? '/master/api/UpdateDynamicData?model=requestSave' : '/master/api/InsertDynamicData?model=requestSave';
        ;
        axios.post(url, JSON.stringify(datas)).then((response) => {
            this.setState({ loading: false });

            if (response.status === 200) {

                this.growl.show({ severity: 'success', summary: null, detail: 'Payroll Added Successfully' });
                setTimeout(() => {

                    this.props.history.push('/payroll-report');
                }, 2000)
            }
            else {

                this.growl.show({ severity: 'error', summary: null, detail: 'Submit Failed' });
            }
        })

    }

    normalizeFieldDescription = (description) => {
        if (!description) return '';
        const value = String(description).trim();
        const normalized = value.toLowerCase().replace(/[_-]+/g, ' ');

        if (['from date', 'fromdate', 'start date', 'startdate', 'start'].includes(normalized)) return 'From Date';
        if (['to date', 'todate', 'end date', 'enddate', 'end'].includes(normalized)) return 'To Date';
        if (['request date', 'requestdate', 'req date', 'reqdate'].includes(normalized)) return 'Request Date';
        if (['comment', 'remarks', 'remark'].includes(normalized)) return 'Comment';
        if (['employee', 'employee id', 'employeeid'].includes(normalized)) return 'Employee';
        if (['organization unit', 'organizationunit', 'org unit', 'orgunit'].includes(normalized)) return 'Organization Unit';
        return value;
    }

    parseCommaSeparatedValues = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value.map(v => String(v).trim()).filter(Boolean);
        return String(value).split(',').map(v => v.trim()).filter(Boolean);
    }

    parseDateValue = (value) => {
        if (!value) return null;
        if (value instanceof Date && !isNaN(value)) return value;

        const date = new Date(value);
        if (!isNaN(date.getTime())) return date;

        const match = String(value).match(/(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})/);
        if (match) {
            const [, month, day, year] = match;
            const fullYear = year.length === 2 ? `20${year}` : year;
            const parsed = new Date(`${fullYear}-${month}-${day}`);
            if (!isNaN(parsed.getTime())) return parsed;
        }

        return null;
    }

    mapRequestPayrollToTableRows = (payrollData = []) => {
        return payrollData.map((payroll, index) => ({
            ...payroll,
            id: payroll.payrollId || payroll.id || index,
            EMPLOYEE_NO: payroll.employeeCode || payroll.EmployeeCode || payroll.employeeId || payroll.EmployeeId || payroll.employeeNo || payroll.EmployeeNo || payroll.EMPLOYEE_NO || '',
            EmployeeName: payroll.employeeName || payroll.EmployeeName || payroll.Name || payroll.employee || '',
            POSITION: payroll.position || payroll.POSITION || payroll.Designation || '',
            DEPARTMENT: payroll.department || payroll.DEPARTMENT || payroll.Department || '',
            PresentDays: payroll.presentDays ?? payroll.PresentDays ?? payroll.PresantDays ?? payroll.PrestentDays ?? 0,
            AbsentDays: payroll.absentDays ?? payroll.absendDays ?? payroll.AbsentDays ?? payroll.AbsendDays ?? 0,
            OffDays: payroll.offDays ?? payroll.OffDays ?? 0,
            Holidays: payroll.holidays ?? payroll.Holidays ?? 0,
            WorkingHours: payroll.totalHours ?? payroll.TotalHours ?? payroll.workingHours ?? payroll.WorkingHours ?? payroll.TotalWorkHours ?? 0,
            attendanceHours: payroll.requiredHours ?? payroll.RequiredHours ?? payroll.attendanceHours ?? payroll.AttendanceHours ?? 0,
            OTHours: payroll.actualOt ?? payroll.ActualOt ?? payroll.otHours ?? payroll.OTHours ?? payroll.ActualOT ?? 0,
            basicsalary: payroll.basicsalary ?? payroll.basicSalary ?? payroll.BasicSalary ?? payroll.BasicSalaryAmount ?? 0,
            bonus: payroll.bonus ?? payroll.Bonus ?? 0,
            hra: payroll.hra ?? payroll.HRA ?? 0,
            tra: payroll.tra ?? payroll.TRA ?? 0,
            esiamount: payroll.esiamount ?? payroll.esiAmount ?? payroll.ESIAmount ?? 0,
            pfamount: payroll.pfamount ?? payroll.pfAmount ?? payroll.PFAmount ?? 0,
            ptamount: payroll.ptamount ?? payroll.ptAmount ?? payroll.PTAmount ?? 0,
            tdsamount: payroll.tdsamount ?? payroll.tdsAmount ?? payroll.TDSAmount ?? 0,
            TotalEarnings: payroll.totalEarnings ?? payroll.TotalEarnings ?? payroll.GrossTotal ?? 0
        }));
    }

    hydrateRequestAttributeFields = (attributeData = []) => {
        const { organizationData, commonData, employeeData } = this.state;
        const employeeList = (commonData && commonData.length > 0 ? commonData : employeeData && employeeData.length > 0 ? employeeData : []);

        attributeData.forEach((attr) => {
            if (!attr || !attr.stage_Field) return;

            attr.stage_Field.forEach((field) => {
                const description = this.normalizeFieldDescription(field && field.fieldDescription);
                if (!description || !field || field.fieldValue === undefined || field.fieldValue === null) return;

                if (description === 'Organization Unit') {
                    const selectedOrgIds = this.parseCommaSeparatedValues(field.fieldValue);
                    const selectedOrganization = selectedOrgIds.length > 0
                        ? (organizationData && organizationData.length > 0 ? organizationData.filter((org) => selectedOrgIds.includes(String(org.orgId))) : [])
                        : [];
                    this.setState({ organizationunit: selectedOrganization, Orgunit: selectedOrganization });
                }

                if (description === 'Employee') {
                    const employeeValues = this.parseCommaSeparatedValues(field.fieldValue);
                    const selectedEmployee = employeeValues.length > 0 && employeeList.length > 0
                        ? employeeList.filter((emp) => {
                            const matchIds = [emp.userNo, emp.employeeId, emp.id, emp.EmployeeId, emp.UserNo];
                            return employeeValues.some((value) => matchIds.map((item) => String(item)).includes(String(value)));
                        })
                        : [];
                    this.setState({ employee: selectedEmployee });
                }

                if (description === 'From Date') {
                    const parsedDate = this.parseDateValue(field.fieldValue);
                    if (parsedDate) this.setState({ startDate: parsedDate });
                }

                if (description === 'To Date') {
                    const parsedDate = this.parseDateValue(field.fieldValue);
                    if (parsedDate) this.setState({ endDate: parsedDate });
                }

                if (description === 'Request Date') {
                    const parsedDate = this.parseDateValue(field.fieldValue);
                    if (parsedDate) this.setState({ requestDate: parsedDate });
                }

                if (description === 'Comment') {
                    this.setState({ comment: field.fieldValue });
                }
            });
        });
    }

    updateFields = (attributeData) => {
        // Step 1: Hydrate form fields from requestAttribute1
        this.hydrateRequestAttributeFields(attributeData || []);

        // Step 2: Hydrate DataTable from requestPayroll
        if (this.props.tableLists && this.props.tableLists.requestPayroll) {
            const tableData = Array.isArray(this.props.tableLists.requestPayroll)
                ? this.props.tableLists.requestPayroll
                : [];

            if (tableData && tableData.length > 0) {
                const mappedData = this.mapRequestPayrollToTableRows(tableData);
                this.setState({ payrollData: mappedData });
            }
        }

        this.isFieldUpdated = true;
    }

    getEmployeeList = () => {
        this.setState({ loading: true });
        axios.get('/master/api/GetEmployeeList').then((response) => {
            if (response.status === 200) {

                if (response.data && response.data.length > 0) {
                    let organizationData = response.data;
                    organizationData = [...new Set(organizationData.map(({ orgId }) => orgId))].map(e => organizationData.find(({ orgId }) => orgId == e));
                    this.setState({ organizationData, commonData: response.data, employeeData: response.data });
                    this.setState({ loading: false });
                }
            }
            else {
                this.setState({ loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong, Try Again later' });
            }
        })

    }

    onEmployeeChange(stateKey, e) {
        this.setState({ [stateKey]: e.target.value });

        if (stateKey === 'organizationunit')
            this.updateEmplyeeData(e.target.value);
    }

    filterEmployeesBySelection = () => {
        this.setState({ loading: true });
        setTimeout(() => {

            const {
                completeempdata = [],
                Vendor = [],
                CostCenter = [],
                EmployeeStatus = [],
                EmployeeType = [],
                Orgunit = [],
                EmployeeSubGroup = [],
                Nationality = [],
                employee = []
            } = this.state;

            const getSelectedValues = (list) => (list || []).map(item => {
                if (item && typeof item === 'object') {
                    return item.value || item.id || item.label || item.name;
                }
                return item;
            }).filter(Boolean).map(val => String(val).toLowerCase());

            const vendorValues = getSelectedValues(Vendor);
            const costCenterValues = getSelectedValues(CostCenter);
            const employeeStatusValues = getSelectedValues(EmployeeStatus);
            const employeeTypeValues = getSelectedValues(EmployeeType);
            const orgUnitValues = getSelectedValues(Orgunit);
            const employeeSubGroupValues = getSelectedValues(EmployeeSubGroup);
            const nationalityValues = getSelectedValues(Nationality);

            const matchSelectedValue = (rawValue, selectedValues) => {
                if (!selectedValues || selectedValues.length === 0) return true;
                if (rawValue === null || rawValue === undefined) return false;

                if (Array.isArray(rawValue)) {
                    const normalized = rawValue.map(v => String(v).toLowerCase());
                    return normalized.some(v => selectedValues.includes(v));
                }

                return selectedValues.includes(String(rawValue).toLowerCase());
            };

            const filtered = completeempdata.filter(emp => {
                const vendorMatch = matchSelectedValue(emp.vendor || emp.Vendor || emp.vendorId || emp.VendorId, vendorValues);
                const costCenterMatch = matchSelectedValue(emp.costcenter || emp.CostCenter || emp.costCenter || emp.COSTCENTER, costCenterValues);
                const statusMatch = matchSelectedValue(emp.employeeStatus || emp.EmployeeStatus || emp.status || emp.STATUS, employeeStatusValues);
                const typeMatch = matchSelectedValue(emp.employeeType || emp.EMPLOYEETYPE || emp.EmployeeType, employeeTypeValues);
                const orgUnitMatch = matchSelectedValue(emp.orgId || emp.orgUnit || emp.OrgUnit || emp.organizationunit || emp.OrganizationUnit, orgUnitValues);
                const subGroupMatch = matchSelectedValue(emp.employeeSubGroup || emp.employeesubgroup || emp.EmployeeSubGroup, employeeSubGroupValues);
                const nationalityMatch = matchSelectedValue(emp.nationality || emp.Nationality || emp.NATIONALITY, nationalityValues);

                return vendorMatch && costCenterMatch && statusMatch && typeMatch && orgUnitMatch && subGroupMatch && nationalityMatch;
            });

            const employeeData = filtered.map(el => Object.assign({}, { ...el }, {
                EMPLOYEE_NO: el.userNo,
                EmployeeName: el.employeeName,
                POSITION: el.postiondescription,
                DEPARTMENT: el.description,
                EMPLOYEETYPE: null,
                label: el.employeeName + '-' + el.costcenter,
                value: el.userNo,
                id: parseInt(el.userNo)
            }));

            const employeeIds = employeeData.map(emp => String(emp.userNo));
            const selectedEmployee = (employee || []).filter(emp => employeeIds.includes(String(emp.userNo)));

            this.setState({
                employeeData,
                employee: selectedEmployee,
                filteredEmployeelist: filtered,
                filterApplied: true,
                loading: false
            });
        }, 1500);
    }

    //export directly from datatable 
    // export = () => {
    //     this.dt.exportCSV();
    // }

    //Custom export with header - Excel Format (.xlsx)
    // Styled like the TimeSheet export: grey title/header bands, orange employee cells, black borders, centred text.
    // The OOXML package is written directly (no extra packages) so cell styles are real and the file opens cleanly in Excel.
    export = () => {
        const { payrollData } = this.state;

        const head = ['Employee Code', 'Employee Name', 'Position', 'Department', 'Email', 'Present Days', 'Absent Days', 'Holidays', 'Attendance Hours', 'Working Hours', 'OT Hours', 'Basic Salary', 'Bonus', 'HRA', 'TRA', 'ESI Amount', 'PF Amount', 'TDS Amount', 'Total Earnings'];
        const numKeys = ['PresentDays', 'AbsentDays', 'Holidays', 'attendanceHours', 'WorkingHours', 'OTHours', 'basicsalary', 'bonus', 'hra', 'tra', 'esiamount', 'pfamount', 'tdsamount', 'TotalEarnings'];
        const widths = [14, 20, 18, 22, 24, 14, 14, 12, 18, 16, 12, 16, 12, 12, 12, 14, 14, 14, 16];
        // [label, first col, last col, border style id] - border colours follow the TimeSheet summary band
        const groups = [['General Info', 0, 4, 3], ['Days Summary', 5, 7, 4], ['Attendance Details & OT', 8, 10, 5], ['Allowance', 11, 14, 3], ['Deductions', 15, 17, 7], ['Total', 18, 18, 6]];
        const lastCol = head.length - 1;

        const clean = (v) => String(v === null || v === undefined ? '' : v).replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F￾￿]/g, '');
        const esc = (v) => clean(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        const colName = (i) => String.fromCharCode(65 + i); // 19 columns: A..S
        const str = (ref, s, v) => (clean(v) === '' ? `<c r="${ref}" s="${s}"/>` : `<c r="${ref}" s="${s}" t="inlineStr"><is><t xml:space="preserve">${esc(v)}</t></is></c>`);
        const numCell = (ref, s, v) => `<c r="${ref}" s="${s}"><v>${isFinite(v) ? parseFloat(Number(v).toFixed(6)) : 0}</v></c>`;

        const rows = [];
        const merges = [];
        const rowXml = (n, cells, h) => `<row r="${n}"${h ? ` ht="${h}" customHeight="1"` : ''}>${cells.join('')}</row>`;

        // Row 1 - title with the selected From Date / To Date in the same header cell
        const { startDate, endDate } = this.state;
        const fmtD = (d) => (d ? moment(d).format('DD/MM/YYYY') : '');
        const title = `PayRoll Report - From Date: ${fmtD(startDate)}  To Date: ${fmtD(endDate)}`;
        merges.push(`A1:${colName(lastCol)}1`);
        rows.push(rowXml(1, head.map((_, i) => str(`${colName(i)}1`, 1, i === 0 ? title : '')), 30));

        // Row 2 - group band
        const r2 = [];
        groups.forEach(([label, from, to, s]) => {
            for (let c = from; c <= to; c++) r2.push(str(`${colName(c)}2`, s, c === from ? label : ''));
            if (to > from) merges.push(`${colName(from)}2:${colName(to)}2`);
        });
        rows.push(rowXml(2, r2, 22));

        // Row 3 - column headers
        rows.push(rowXml(3, head.map((h, i) => str(`${colName(i)}3`, 8, h)), 22));

        // Data rows - one per employee
        const totals = numKeys.map(() => 0);
        let n = 4;
        (payrollData || []).forEach(row => {
            const cells = [row.EMPLOYEE_NO, row.EmployeeName, row.POSITION, row.DEPARTMENT, row.email].map((v, i) => str(`${colName(i)}${n}`, 9, v));
            numKeys.forEach((k, i) => {
                const v = parseFloat(row[k]) || 0;
                totals[i] += v;
                cells.push(numCell(`${colName(5 + i)}${n}`, 10, v));
            });
            rows.push(rowXml(n, cells, 18));
            n += 1;
        });

        // Total row
        const t = [];
        for (let c = 0; c <= 4; c++) t.push(str(`${colName(c)}${n}`, 11, c === 0 ? 'TOTAL' : ''));
        totals.forEach((v, i) => t.push(numCell(`${colName(5 + i)}${n}`, 12, v)));
        merges.push(`A${n}:E${n}`);
        rows.push(rowXml(n, t, 20));

        const sheetXml = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
            + '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
            + `<dimension ref="A1:${colName(lastCol)}${n}"/>`
            + '<sheetViews><sheetView workbookViewId="0"><pane ySplit="3" topLeftCell="A4" activePane="bottomLeft" state="frozen"/></sheetView></sheetViews>'
            + '<sheetFormatPr defaultRowHeight="15"/>'
            + `<cols>${widths.map((w, i) => `<col min="${i + 1}" max="${i + 1}" width="${w + 2}" customWidth="1"/>`).join('')}</cols>`
            + `<sheetData>${rows.join('')}</sheetData>`
            + `<mergeCells count="${merges.length}">${merges.map(m => `<mergeCell ref="${m}"/>`).join('')}</mergeCells>`
            + '<pageMargins left="0.5" right="0.5" top="0.75" bottom="0.75" header="0.3" footer="0.3"/>'
            + '<pageSetup orientation="landscape"/>'
            + '</worksheet>';

        const side = (name, color) => `<${name} style="thin"><color rgb="${color}"/></${name}>`;
        const box = (color) => `<border>${side('left', color)}${side('right', color)}${side('top', color)}${side('bottom', color)}<diagonal/></border>`;
        const xf = (font, fill, border) => `<xf numFmtId="0" fontId="${font}" fillId="${fill}" borderId="${border}" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="center" vertical="center" wrapText="1"/></xf>`;
        // borders: 0 none, 1 black, 2 green, 3 red, 4 orange, 5 blue  |  fills: 2 #bebcbc, 3 #a1a1a1, 4 #cac9c9, 5 #eb9c4d
        const stylesXml = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
            + '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
            + '<fonts count="3"><font><sz val="11"/><name val="Calibri"/></font><font><b/><sz val="11"/><name val="Calibri"/></font><font><b/><sz val="18"/><name val="Calibri"/></font></fonts>'
            + '<fills count="6"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill>'
            + ['FFBEBCBC', 'FFA1A1A1', 'FFCAC9C9', 'FFEB9C4D'].map(c => `<fill><patternFill patternType="solid"><fgColor rgb="${c}"/><bgColor indexed="64"/></patternFill></fill>`).join('') + '</fills>'
            + `<borders count="6"><border><left/><right/><top/><bottom/><diagonal/></border>${['FF000000', 'FF00B050', 'FFFF0000', 'FFFFA500', 'FF0000FF'].map(box).join('')}</borders>`
            + '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>'
            + '<cellXfs count="14">'
            + '<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>'  // 0 default
            + xf(2, 2, 1)   // 1 title
            + xf(1, 3, 1)   // 2 (spare)
            + xf(1, 3, 2)   // 3 group - green
            + xf(1, 3, 3)   // 4 group - red
            + xf(1, 3, 4)   // 5 group - orange
            + xf(1, 3, 2)   // 6 group - green
            + xf(1, 3, 5)   // 7 group - blue
            + xf(1, 4, 1)   // 8 column header
            + xf(0, 5, 1)   // 9 employee info (orange)
            + xf(0, 0, 1)   // 10 numbers
            + xf(1, 3, 1)   // 11 total label
            + xf(1, 3, 1)   // 12 total numbers
            + xf(1, 2, 1)   // 13 dates next to title
            + '</cellXfs>'
            + '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>'
            + '</styleSheet>';

        const NS = 'http://schemas.openxmlformats.org/';
        const files = [
            ['[Content_Types].xml', '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/></Types>'],
            ['_rels/.rels', `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="${NS}officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>`],
            ['xl/workbook.xml', `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="${NS}spreadsheetml/2006/main" xmlns:r="${NS}officeDocument/2006/relationships"><sheets><sheet name="Payroll Report" sheetId="1" r:id="rId1"/></sheets></workbook>`],
            ['xl/_rels/workbook.xml.rels', `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="${NS}officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/><Relationship Id="rId2" Type="${NS}officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>`],
            ['xl/styles.xml', stylesXml],
            ['xl/worksheets/sheet1.xml', sheetXml],
        ];

        // Minimal ZIP writer (stored, no compression) - an .xlsx is just a zip of XML parts
        const enc = new TextEncoder();
        const crcTable = [];
        for (let k = 0; k < 256; k++) {
            let c = k;
            for (let j = 0; j < 8; j++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
            crcTable.push(c >>> 0);
        }
        const crc32 = (u8) => {
            let c = 0xFFFFFFFF;
            for (let k = 0; k < u8.length; k++) c = crcTable[(c ^ u8[k]) & 0xFF] ^ (c >>> 8);
            return (c ^ 0xFFFFFFFF) >>> 0;
        };
        const parts = [];
        const central = [];
        let offset = 0;
        files.forEach(([name, text]) => {
            const nameB = enc.encode(name);
            const data = enc.encode(text);
            const crc = crc32(data);
            const lh = new DataView(new ArrayBuffer(30));
            lh.setUint32(0, 0x04034b50, true); lh.setUint16(4, 20, true); lh.setUint16(6, 0x0800, true); lh.setUint16(8, 0, true);
            lh.setUint16(10, 0, true); lh.setUint16(12, 0x21, true); lh.setUint32(14, crc, true);
            lh.setUint32(18, data.length, true); lh.setUint32(22, data.length, true); lh.setUint16(26, nameB.length, true); lh.setUint16(28, 0, true);
            const ch = new DataView(new ArrayBuffer(46));
            ch.setUint32(0, 0x02014b50, true); ch.setUint16(4, 20, true); ch.setUint16(6, 20, true); ch.setUint16(8, 0x0800, true); ch.setUint16(10, 0, true);
            ch.setUint16(12, 0, true); ch.setUint16(14, 0x21, true); ch.setUint32(16, crc, true);
            ch.setUint32(20, data.length, true); ch.setUint32(24, data.length, true); ch.setUint16(28, nameB.length, true);
            ch.setUint32(42, offset, true);
            parts.push(new Uint8Array(lh.buffer), nameB, data);
            central.push(new Uint8Array(ch.buffer), nameB);
            offset += 30 + nameB.length + data.length;
        });
        const cdSize = central.reduce((a, b) => a + b.length, 0);
        const end = new DataView(new ArrayBuffer(22));
        end.setUint32(0, 0x06054b50, true); end.setUint16(8, files.length, true); end.setUint16(10, files.length, true);
        end.setUint32(12, cdSize, true); end.setUint32(16, offset, true);

        const blob = new Blob([...parts, ...central, new Uint8Array(end.buffer)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'PayrollReport.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }

    // PDF export - styled like RestaurantDailySalesReport (landscape A4, pink header, vertical column lines, bold total row)
    exportPdf = () => {
        const { payrollData } = this.state;
        if (!payrollData || payrollData.length === 0) {
            return;
        }
        this.buildPdf();
    }

    buildPdf = () => {
        const { payrollData } = this.state;
        const num = (v) => Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const head = ['Employee Code', 'Employee Name', 'Position', 'Department', 'Email', 'Present Days', 'Absent Days', 'Holidays', 'Attendance Hours', 'Working Hours', 'OT Hours', 'Basic Salary', 'Bonus', 'HRA', 'TRA', 'ESI Amount', 'PF Amount', 'TDS Amount', 'Total Earnings'];
        const keys = ['PresentDays', 'AbsentDays', 'Holidays', 'attendanceHours', 'WorkingHours', 'OTHours', 'basicsalary', 'bonus', 'hra', 'tra', 'esiamount', 'pfamount', 'tdsamount', 'TotalEarnings'];
        const totals = keys.map(() => 0);
        const body = payrollData.map(row => {
            const vals = keys.map((k, i) => {
                const n = parseFloat(row[k]) || 0;
                totals[i] += n;
                return n;
            });
            return [row.EMPLOYEE_NO || '', row.EmployeeName || '', row.POSITION || '', row.DEPARTMENT || '', row.email || '', ...vals.map(num)];
        });
        body.push(['TOTAL', '', '', '', '', ...totals.map(num)]);

        const doc = new jsPDF({ orientation: 'l', unit: 'mm', format: 'a4', compress: true });
        const startY = 32;
        const fmtD = (d) => (d ? moment(d).format('DD/MM/YYYY') : '');
        doc.addImage(chenthoorLandscapeLogo, 'PNG', 10, 5, 40, 20, 'chenthoorLogo', 'FAST'); // x, y, width, height
        const pageW = doc.internal.pageSize.getWidth();
        doc.setFont('times', 'bold');
        doc.setFontSize(20);
        doc.setTextColor(31, 78, 121);
        doc.text('PayRoll Report', pageW / 2, 16, { align: 'center' });
        doc.setDrawColor(157, 195, 230);
        doc.setLineWidth(0.6);
        doc.line(pageW / 2 - 25, 19, pageW / 2 + 25, 19);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        doc.setTextColor(60);
        doc.text(`From Date: ${fmtD(this.state.startDate)}      To Date: ${fmtD(this.state.endDate)}`, pageW - 10, 26, { align: 'right' });
        doc.setTextColor(0);

        // Manual table drawing (no jspdf-autotable): same look - pink header, vertical column lines, bold total row
        const marginX = 10;
        const pageBottom = 200;
        const fontSize = 6;
        const pad = 1.5;
        const lineH = fontSize * 0.3528 * 1.2;
        const colW = [14, 24, 18, 20, 34, ...keys.map(() => 11.9)];
        const colAlign = ['center', 'left', 'left', 'left', 'left', ...keys.map(() => 'right')];
        const tableW = colW.reduce((a, b) => a + b, 0);
        let y = startY;

        const drawRow = (cells, opts) => {
            doc.setFont('helvetica', opts.bold ? 'bold' : 'normal');
            doc.setFontSize(fontSize);
            const wrapped = cells.map((c, i) => doc.splitTextToSize(String(c), colW[i] - 2 * pad));
            const rowH = Math.max(...wrapped.map(w => w.length)) * lineH + 2 * pad;
            if (y + rowH > pageBottom) {
                doc.addPage();
                y = 10;
                if (!opts.isHead) {
                    drawRow(head, { isHead: true, bold: true });
                    doc.setFont('helvetica', opts.bold ? 'bold' : 'normal');
                }
            }
            let x = marginX;
            cells.forEach((c, i) => {
                if (opts.isHead) {
                    doc.setFillColor(157, 195, 230); // light blue header
                    doc.rect(x, y, colW[i], rowH, 'F');
                } else if (opts.bold) {
                    doc.setFillColor(189, 215, 238); // total row
                    doc.rect(x, y, colW[i], rowH, 'F');
                } else if (opts.shaded) {
                    doc.setFillColor(234, 243, 252); // alternate row
                    doc.rect(x, y, colW[i], rowH, 'F');
                }
                doc.setDrawColor(120, 150, 190);
                doc.setLineWidth(0.2);
                doc.line(x, y, x, y + rowH);
                if (i === cells.length - 1) doc.line(x + colW[i], y, x + colW[i], y + rowH);
                const align = opts.isHead ? 'center' : colAlign[i];
                const tx = align === 'center' ? x + colW[i] / 2 : align === 'right' ? x + colW[i] - pad : x + pad;
                doc.setTextColor(0);
                doc.text(wrapped[i], tx, y + pad + lineH * 0.8, { align });
                x += colW[i];
            });
            doc.line(marginX, y + rowH, marginX + tableW, y + rowH);
            if (opts.isHead) doc.line(marginX, y, marginX + tableW, y);
            y += rowH;
        };

        drawRow(head, { isHead: true, bold: true });
        body.forEach((r, idx) => drawRow(r, { bold: idx === body.length - 1, shaded: idx % 2 === 1 }));
        // Footer on every page: generated date and time
        const generatedOn = moment().format('DD/MM/YYYY hh:mm A');
        const pageH = doc.internal.pageSize.getHeight();
        const pages = doc.internal.getNumberOfPages();
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.setTextColor(80);
        for (let i = 1; i <= pages; i++) {
            doc.setPage(i);
            doc.text(`Generated on: ${generatedOn}`, marginX, pageH - 5);
            doc.text(`Page ${i} of ${pages}`, pageW - 10, pageH - 5, { align: 'right' });
        }
        doc.save('PayrollReport.pdf');
    }

    getDateOnFormat = (date) => {
        return date && date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    }

    simulateOnClick = () => {
        const { employee, startDate, endDate, comment, requestDate, Generate } = this.state;
        if (!employee || !startDate || !endDate || !comment || !requestDate) {
            if (!employee) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Select Employee Before Generating Data' })
                return
            } else if (!startDate) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Select From Date Before Generating Data' })
                return
            } else if (!endDate) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Select To Date Before Generating Data' })
                return
            } else if (!comment) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Enter Your Comments Before Generating Data' })
                return
            } else if (!requestDate) {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Please Select Request Date Before Generating Data' })
                return
            } else {
                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Something Went Wrong' })
                return
            }
        }
        console.log(employee);
        const empId = employee.map(emp => emp.userNo).join(',');
        const fromDate = this.getDateOnFormat(startDate);
        const toDate = this.getDateOnFormat(endDate);

        this.setState({ loading: true });
        axios.get(`master/api/GetEmployeePayRollDetails?EmployeeId=${employee}&FromDate=${fromDate}&ToDate=${toDate}&generate=${Generate}`).
            then((response) => {
                this.setState({ loading: false });
                if (response.status === 200) {
                    if (response.data) {
                        this.setState({ payrollData: response.data.Table });
                    }
                }
                else {
                    this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong, Try Again later' });
                }
            })

    }

    updateEmplyeeData = (selectedOrganization, selectedEmployee) => {
        const { commonData, employee } = this.state;

        if (!selectedOrganization || selectedOrganization.length <= 0) {
            this.setState({ employeeData: [], employee: [] });
            return;
        }

        const selectedOrganizations = selectedOrganization && selectedOrganization.map(org => org.orgId)
        const employeeData = commonData.filter((common) => {
            return selectedOrganization && selectedOrganizations.includes(common.orgId);
        });

        if (selectedEmployee) {
            let filteredEmp = employeeData.filter((emp) => selectedEmployee.includes(emp.employeeId));
            this.setState({ employeeData, employee: filteredEmp });
        }
        else {
            let filteredEmp = employee && employee.filter(e => selectedOrganizations && selectedOrganizations.includes(e.orgId));
            this.setState({ employeeData, employee: filteredEmp });
        }
    }

    getRequestPayroll = () => {
        let requestPayroll = [];
        const { payrollData, startDate, endDate } = this.state;
        payrollData && payrollData.map((payroll) => {
            requestPayroll.push(
                {
                    // EmployeeId: String(payroll.EMPLOYEE_NO),
                    StartDate: moment(startDate).format('MM/DD/YYYY'),
                    EndDate: moment(endDate).format('MM/DD/YYYY'),
                    EmployeeCode: payroll.EMPLOYEE_NO,
                    EmployeeName: payroll.EmployeeName,
                    PresentDays: payroll.PresentDays || 0,
                    AbsendDays: payroll.AbsentDays || 0,
                    OffDays: payroll.OffDays || 0,
                    TodatShiftDays: 0,
                    LateIn: payroll.LateInHours || 0,
                    EarlyOut: payroll.EarlyOutHours || 0,
                    PreApprovedOt: 0,
                    ActualOt: payroll.OTHours || 0,
                    PermissionHours: 0,
                    UnpaidLeave: 0,
                    TotalHours: payroll.WorkingHours || 0,
                    RequiredHours: payroll.attendanceHours || 0,
                    RegularHours: 0,

                    Holidays: payroll.Holidays || 0,
                    BasicSalary: payroll.basicsalary || 0,
                    Bonus: payroll.bonus || 0,
                    HRA: payroll.hra || 0,
                    TRA: payroll.tra || 0,
                    PF: payroll.pf || 0,
                    ESI: payroll.esi || 0,
                    PT: payroll.pt || 0,
                    TDS: payroll.tds || 0,
                    PFAmount: payroll.pfamount || 0,
                    ESIAmount: payroll.esiamount || 0,
                    PTAmount: payroll.ptamount || 0,
                    TDSAmount: payroll.tdsamount || 0,

                    ReportedBy: this.props.loggedUserDetail.empID
                }
            )
        });

        return requestPayroll;
    }

    rowExpansionTemplate = (data) => {

        return (
            <div className="p-grid p-fluid" style={{ padding: '2em 1em 1em 1em' }}>
                <div className="p-col-12 p-md-12">
                    <div className="p-grid">
                        {/* General Info */}
                        <div className="p-md-3">Employee Code: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.EMPLOYEE_NO}</div>

                        <div className="p-md-3">Name: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.EmployeeName}</div>

                        <div className="p-md-3">Department: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.DEPARTMENT}</div>

                        <div className="p-md-3">Position: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.POSITION}</div>

                        <div className="p-md-3">Email: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.email}</div>

                        {/* Days Summary */}
                        <div className="p-md-3">Present Days: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.PresentDays}</div>

                        <div className="p-md-3">Absent Days: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.AbsentDays}</div>

                        <div className="p-md-3">Holidays: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Holidays}</div>

                        {/* Attendance Details & OT */}
                        <div className="p-md-3">Attendance Hours: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.attendanceHours}</div>

                        <div className="p-md-3">Working Hours: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.WorkingHours}</div>

                        <div className="p-md-3">OT Hours: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.OTHours}</div>

                        {/* Allowance */}
                        <div className="p-md-3">Basic Salary: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.basicsalary}</div>

                        <div className="p-md-3">Bonus: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.bonus}</div>

                        <div className="p-md-3">HRA (Housing Allowance): </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.hra}</div>

                        <div className="p-md-3">TRA (Transport Allowance): </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.tra}</div>

                        {/* Deductions */}
                        <div className="p-md-3">ESI Amount: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.esiamount}</div>

                        <div className="p-md-3">PF Amount: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.pfamount}</div>

                        <div className="p-md-3">TDS Amount: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.tdsamount}</div>

                        {/* Total */}
                        <div className="p-md-3">Total Earnings: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.TotalEarnings}</div>
                    </div>
                </div>
            </div>
        );
    }

    clearEmployeeFilter = () => {
        this.setState({ loading: true });
        setTimeout(() => {
            const employeeData = (this.state.completeempdata || []).map(el => Object.assign({}, { ...el }, {
                EMPLOYEE_NO: el.userNo,
                EmployeeName: el.employeeName,
                POSITION: el.postiondescription,
                DEPARTMENT: el.description,
                EMPLOYEETYPE: null,
                label: el.employeeName + '-' + el.costcenter,
                value: el.userNo,
                id: parseInt(el.userNo)
            }));

            this.setState({
                // Reset all bound filter controls
                Vendor: [],
                CostCenter: [],
                EmployeeStatus: [],
                EmployeeType: [],
                Orgunit: [],
                EmployeeSubGroup: [],
                Nationality: [],
                employee: [],

                // Keep legacy keys in sync where they exist in initial state
                employeeStatus: [],
                employeeType: [],
                OrgUnit: [],
                employeeSubGroup: [],
                nationality: [],

                filteredEmployeeData: [],
                filteredEmployeelist: [],
                employeeData,
                filterApplied: false,
                loading: false
            });
        }, 1000);
    }

    // dropdownChange = (e) => {
    //     e.preventDefault();
    //     const { name, value } = e.target;

    //     if (name === 'Division' || name === 'BusinessUnit' || name === 'Department') {
    //         const ListData = { key: value.join(',') };

    //         axios.post(`/master/api/Org/GetSubordinateOrg`, ListData)
    //             .then(response => {
    //                 if (response.status === 200) {
    //                     let data = [];

    //                     this.getEmployeeListOrg();
    //                     if (response.data) {
    //                         data = response.data && response.data.length > 0 && response.data.map(list => {
    //                             return Object.assign({}, { ...list }, { label: list.description, value: list.orgId });
    //                         }) || [];

    //                         if (name === 'Division')
    //                             this.setState({ DepartmentData: data })
    //                         else if (name === 'Department')
    //                             this.setState({ BusinessUnitData: data })
    //                         else
    //                             this.setState({ SectionData: data })
    //                     }
    //                 } else {
    //                     this.setState({ loading: false });
    //                     this.growl.show({ severity: 'error', summary: null, detail: 'subordinate API Failed' });
    //                 }
    //             })
    //             .catch(err => {
    //                 this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'subordinate API Failed' });
    //             });

    //     }



    //     if (name === 'Division') {
    //         this.setState({
    //             expandedRows: false,
    //             BusinessUnitData: [],
    //             DepartmentData: [],
    //             SectionData: [],
    //             Division: value,
    //             BusinessUnit: false,
    //             Department: false,
    //             Section: false
    //         });
    //     } else {
    //         this.setState({ [name]: value });
    //     }


    //     if(name === 'Section'){
    //         this.setState({ loading: true});
    //         setTimeout(() => this.getEmployeeListOrg(), 2000);
    //     }
    // }

    // getEmployeeListOrg = (list) => {
    //     const { Division, BusinessUnit, Department, Section } = this.state;

    //     const DivisionData = Division && Division.length > 0 && Division.join(',') || '';
    //     const BusinessUnitData = BusinessUnit && BusinessUnit.length > 0 && BusinessUnit.join(',') || '';
    //     const DepartmentData = Department && Department.length > 0 && Department.join(',') || '';
    //     const SectionData = Section && Section.length > 0 && Section.join(',') || '';
    //     const filterList = { key: DivisionData + BusinessUnitData + DepartmentData + SectionData };

    //     axios.post(`/master/api/GetEmployeeListForOrg`, filterList).then((response) => {
    //         if (response.status === 200) {
    //             if (response.data) {
    //                 const employeeData = response.data && response.data.length > 0 && response.data.map(el => Object.assign({}, { ...el }, { EMPLOYEE_NO: el.userNo, EmployeeName: el.employeeName, POSITION: el.postiondescription, DEPARTMENT: el.description, EMPLOYEETYPE: null })) || [];

    //                 this.setState({ employeeData, loading: false });
    //             }
    //         }
    //         else {
    //             this.setState({ loading: false });
    //             this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong, Try Again later' });
    //         }
    //     }).catch(err => {
    //         this.setState({ loading: false });
    //         this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Something went wrong, Try Again later' });

    //     })

    // }


    getEmployeeList = () => {
        axios.get('/master/api/GetEmployeeList').then((response) => {
            if (response.status === 200) {
                if (response.data && response.data.length > 0) {

                    const employeeData = response.data.map(el => Object.assign({}, { ...el }, { EMPLOYEE_NO: el.userNo, EmployeeName: el.employeeName, POSITION: el.postiondescription, DEPARTMENT: el.description, EMPLOYEETYPE: null, label: el.employeeName + '-' + el.costcenter, value: el.userNo, id: parseInt(el.userNo) }))

                    this.setState({ completeempdata: response.data, employeeData, loading: false });
                }
            }
            else {
                this.growl.show({ severity: 'error', summary: null, detail: 'Something went wrong, Try Again later' });
            }
        }).catch(err => {
            this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Something went wrong, Try Again later' });

        })

    }

    render() {
        const header = (
            <div style={{ 'textAlign': 'right' }}>
                <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search..." />
            </div>
        );

        const { stageSequence } = this.state;
        const status = this.props.tableLists && Object.keys(this.props.tableLists).length > 0 && this.props.tableLists.status;
        const pageType = this.props.match && this.props.match.params && this.props.match.params.type;
        const pendingWith = this.props.location && this.props.location.state && this.props.location.state.pendingWith;

        return (
            <div className="p-col-12 approvalPath">
                <div className="p-col-12">
                    {this.props.loading || this.state.loading && <div className="page-loader"></div>}
                    <Toast ref={(el) => this.growl = el} style={{ marginTop: '75px' }} />
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Add Payroll Report
                            <Link to={'/payroll-report'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} />
                    </div>
                </div>

                <div className="card card-w-title">
                    <div className="p-grid">

                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Vendor</label>
                            <div className="mt1 ">
                                <MultiSelect
                                    name="Vendor"
                                    style={{ width: '100%', padding: '7px' }}
                                    disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')}
                                    placeholder="Select Vendor"
                                    filter={true}
                                    filterBy={"label,value,id,name"}
                                    optionLabel="label"
                                    value={this.state.Vendor}
                                    options={this.props.Vendor || []}
                                    onChange={(e) => this.onEmployeeChange('Vendor', e)}
                                    showClear />
                            </div>
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Cost Center</label>
                            <div className="mt1 ">
                                <MultiSelect
                                    name="costcenter"
                                    style={{ width: '100%', padding: '7px' }}
                                    disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')}
                                    placeholder="Select Cost Center"
                                    filter={true}
                                    filterBy={"label,value,id,name"}
                                    optionLabel="label"
                                    value={this.state.CostCenter}
                                    options={this.props.CostCenter || []}
                                    onChange={(e) => this.onEmployeeChange('CostCenter', e)}
                                    showClear />
                            </div>
                        </div>

                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Employee Status</label>
                            <div className="mt1 ">
                                <MultiSelect
                                    name="employeestatus"
                                    style={{ width: '100%', padding: '7px' }}
                                    disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')}
                                    placeholder="Select Employee Status"
                                    filter={true}
                                    filterBy={"label,value,id,name"}
                                    optionLabel="label"
                                    value={this.state.EmployeeStatus}
                                    options={this.props.EmployeeStatus || []}
                                    onChange={(e) => this.onEmployeeChange('EmployeeStatus', e)}
                                    showClear />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Employee Type</label>
                            <div className="mt1 ">
                                <MultiSelect
                                    name="employeetype"
                                    style={{ width: '100%', padding: '7px' }}
                                    disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')}
                                    placeholder="Select Employee Type"
                                    filter={true}
                                    filterBy={"label,value,id,name"}
                                    optionLabel="label"
                                    value={this.state.EmployeeType}
                                    options={this.props.EmployeeType || []}
                                    onChange={(e) => this.onEmployeeChange('EmployeeType', e)}
                                    showClear />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Organization Unit</label>
                            <div className="mt1 ">
                                <MultiSelect
                                    name="Orgunit"
                                    style={{ width: '100%', padding: '7px' }}
                                    disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')}
                                    placeholder="Select Organization Unit"
                                    filter={true}
                                    filterBy={"label,value,id,name"}
                                    optionLabel="label"
                                    value={this.state.Orgunit}
                                    options={this.props.Orgunit || []}
                                    onChange={(e) => this.onEmployeeChange('Orgunit', e)}
                                    showClear />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Employee Sub Group</label>
                            <div className="mt1 ">
                                <MultiSelect
                                    name="employeesubgroup"
                                    style={{ width: '100%', padding: '7px' }}
                                    disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')}
                                    placeholder="Select Employee Sub Group"
                                    filter={true}
                                    filterBy={"label,value,id,name"}
                                    optionLabel="label"
                                    value={this.state.EmployeeSubGroup}
                                    options={this.props.EmployeeSubGroup || []}
                                    onChange={(e) => this.onEmployeeChange('EmployeeSubGroup', e)}
                                    showClear />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Nationality</label>
                            <div className="mt1 ">
                                <MultiSelect
                                    name="nationality"
                                    style={{ width: '100%', padding: '7px' }}
                                    disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')}
                                    placeholder="Select Nationality"
                                    filter={true}
                                    filterBy={"label,value,id,name"}
                                    optionLabel="label"
                                    value={this.state.Nationality}
                                    options={this.props.Nationality || []}
                                    onChange={(e) => this.onEmployeeChange('Nationality', e)}
                                    showClear />
                            </div>
                        </div>
                    </div>
                    <div className="p-grid">
                        {/*<div className="p-col-12 p-md-6 p-lg-2">
                            <div className="mt1 ">
                                <MultiSelect style={{ width: '100%', margin: "0px" }} disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} placeholder="Select Organization Unit" filter={true} filterBy={"name,description,orgNo"} optionLabel="name" value={this.state.organizationunit} options={this.state.organizationData} onChange={(e) => { this.onEmployeeChange('organizationunit', e) }} showClear />
                            </div>
                        </div>*/}
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Select Employee(s) <span className="requiredColor">*</span></label>
                            <div className="mt1 ">
                                <MultiSelect style={{ width: '100%', padding: '7px' }} disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} placeholder="Select Employee" filter={true} filterBy={"employeeId,employeeName,userNo"} optionLabel="employeeName" value={this.state.employee} options={this.state.employeeData} onChange={(e) => this.onEmployeeChange('employee', e)} showClear />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">From Date <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Calendar placeholder="From Date" disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} className="width100" name="startDate" value={this.state.startDate} onChange={(e) => this.setState({ startDate: e.target.value })} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">To Date <span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Calendar placeholder="To Date" disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} className="width100" name="endDate" value={this.state.endDate} onChange={(e) => this.setState({ endDate: e.target.value })} />

                            </div>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">Request Date<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Calendar placeholder="Request Date" disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} className="width100" name="requestDate" value={this.state.requestDate} onChange={(e) => this.setState({ requestDate: e.target.value })} />
                            </div>
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <div className="mt1">
                                <Button label="Get Employees" style={{ height: '42px', minWidth: '110px', marginLeft: '10px' }} disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} className="p-button-info" onClick={this.filterEmployeesBySelection} icon="pi pi-users" />
                                <Button label="Clear Filter" style={{ height: '42px', minWidth: '110px', marginLeft: '10px' }} disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} className="p-button-warning" onClick={(e) => this.clearEmployeeFilter()} icon="pi pi-times" />
                                <Button label="Generate Data" style={{ height: '42px', minWidth: '110px', marginLeft: '10px' }} disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} className="p-button-secondary" onClick={(e) => this.simulateOnClick()} icon="pi pi-upload" />

                                <Checkbox name="Generate" inputId="gen" style={{ marginLeft: '10px' }} onChange={(e) => this.setState({ Generate: e.target.checked })} checked={this.state.Generate} />
                                <label htmlFor="gen" className="p-checkbox-label">Run Time Evaluation</label>
                            </div>
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-12 p-lg-12 mt1">
                            <label className="label">Comments<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <InputTextarea disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} className="p-col-6" value={this.state.comment} placeholder="Enter your comments" rows={3} name="payrollComment" onChange={(e) => this.setState({ comment: e.target.value })} autoResize={true}>{this.state.comment || ''}</InputTextarea>
                                <Tooltip title="Export as PDF Format">
                                    <Button disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} onClick={this.exportPdf} style={{ float: 'right' }} label="Export PDF" icon="pi pi-download" className="p-button-secondary ml1" />
                                </Tooltip>
                                <Button disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} onClick={this.export} style={{ float: 'right' }} label="Export Excel" icon="pi pi-download" className="p-button-secondary" />
                            </div>
                        </div>
                    </div>
                    <DataTable expandableRowGroups={false} disabled={(stageSequence == 1 || status == 'REQUESTER SUBMITTED')} ref={(el) => this.dt = el} responsive value={this.state.payrollData} paginator={true} rows={50} header={header}
                        globalFilter={this.state.globalFilter} emptyMessage="No records found" className="mt3" expandedRows={this.state.expandedRows} onRowToggle={(e) => { this.setState({ expandedRows: e.data }) }}
                        rowExpansionTemplate={this.rowExpansionTemplate} dataKey="EMPLOYEE_NO">
                        <Column expander={true} style={{ width: '3em' }} />
                        {/* General Info */}
                        <Column field="EMPLOYEE_NO" header="Employee Code" headerClassName="payroll-column" />
                        <Column field="EmployeeName" header="Employee Name" headerClassName="payroll-column" />
                        <Column field="POSITION" header="Position" headerClassName="payroll-column" />
                        <Column field="DEPARTMENT" header="Department" headerClassName="payroll-column" />
                        {/* Days Summary */}
                        <Column field="PresentDays" header="Present Days" headerClassName="payroll-column" />
                        <Column field="AbsentDays" header="Absent Days" headerClassName="payroll-column" />
                        <Column field="Holidays" header="Holidays" headerClassName="payroll-column" />
                        {/* Attendance & OT */}
                        <Column field="attendanceHours" header="Attendance Hours" headerClassName="payroll-column" />
                        <Column field="WorkingHours" header="Working Hours" headerClassName="payroll-column" />
                        <Column field="OTHours" header="OT Hours" headerClassName="payroll-column" />
                        {/* Allowances */}
                        <Column field="basicsalary" header="Basic Salary" headerClassName="payroll-column" />
                        <Column field="bonus" header="Bonus" headerClassName="payroll-column" />
                        <Column field="hra" header="HRA" headerClassName="payroll-column" />
                        <Column field="tra" header="TRA" headerClassName="payroll-column" />
                        {/* Deductions */}
                        <Column field="esiamount" header="ESI Amount" headerClassName="payroll-column" />
                        <Column field="pfamount" header="PF Amount" headerClassName="payroll-column" />
                        <Column field="tdsamount" header="TDS Amount" headerClassName="payroll-column" />
                        {/* Total */}
                        <Column field="TotalEarnings" header="Total Earnings" headerClassName="payroll-column" />
                    </DataTable>

                    { /* ==== Footer Button Logics (Approver vs Requester) ==== */}
                    {parseInt(stageSequence) > 0 ? (
                        <div className="p-col-12 p-md-12 p-lg-12">
                            <div className="card card-w-title">
                                <h1>Approver {stageSequence}</h1>
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <label className="label">Comment <span className="requiredColor">*</span></label>
                                        <div className="mt1">
                                            <textarea className="p-inputtext p-inputtextarea p-component p-col-12" name="approverComment" value={this.state.approverComment || ''} placeholder="Comment" onChange={(e) => { this.setState({ approverComment: e.target.value }) }} disabled={(pageType === 'edit' && pendingWith === null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} />
                                        </div>
                                    </div>
                                </div>
                                <div className="mt1" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
                                    <Button disabled={(pageType === 'edit' && pendingWith === null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-check" />
                                    <Button disabled={(pageType === 'edit' && pendingWith === null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                    {/* <Button disabled={(pageType === 'edit' && pendingWith === null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" /> */}
                                    <Link to={'/payroll-report'}>
                                        <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="mt1 p-col-12 p-lg-12 p-md-12" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
                            <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary" label="Save" icon="pi pi-save" />
                            <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Submit" icon="pi pi-save" />
                            <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger" label="Cancel" onClick={() => this.saveRequest('cancel')} />
                            <Link to={'/payroll-report'}>
                                <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                            </Link>
                        </div>
                    )}
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        getEmployeeDivisionData: (data) => dispatch(actions.getEmployeeDivisionData(data)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),

    }
}

const mapStateToProps = state => {
    const emplist = state?.master?.keywordValuesList?.map(e => ({ ...e, value: e.id })) || [];

    return {
        loggedUserDetail: state.auth.userObject,
        userPosInfo: state.auth.userPosInfo,
        processData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        DivisionData: state.master.employeeDivisionData,

        CostCenter: state.keyword.CostCenter,
        Vendor: state.keyword.Vendor,
        EmployeeType: state.keyword.EMPLOYEETYPE,
        EmployeeSubGroup: state.keyword.employeesubgroup,
        Nationality: state.keyword.nationality,
        EmployeeStatus: state.keyword.EmployeeStatus,
        Orgunit: state.keyword.OrgUnit,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPayrollReport);